import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const ReportCardPagination = ({
  currentPage = 1,
  pageSize = 25,
  totalItems = 0,
  onPageChange,
  onPageSizeChange
}) => {
  const totalPages = Math.ceil(totalItems / pageSize) || 1;
  const startItem = totalItems === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalItems);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '12px 16px',
      background: '#ffffff',
      border: '1px solid #e2e8f0',
      borderRadius: '8px',
      marginTop: '12px',
      fontSize: '12px',
      color: '#64748b',
      flexWrap: 'wrap',
      gap: '10px'
    }}>
      {/* Items Count & Page Size */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <span>
          Showing <strong>{startItem}</strong> - <strong>{endItem}</strong> of <strong>{totalItems}</strong> students
        </span>

        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span>Rows per page:</span>
          <select
            value={pageSize}
            onChange={(e) => {
              onPageSizeChange(parseInt(e.target.value, 10));
              onPageChange(1);
            }}
            style={{
              padding: '4px 8px',
              fontSize: '12px',
              fontWeight: '600',
              borderRadius: '4px',
              border: '1px solid #cbd5e1',
              background: '#ffffff',
              cursor: 'pointer'
            }}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </div>

      {/* Page Navigation */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <button
          type="button"
          disabled={currentPage <= 1}
          onClick={() => onPageChange(currentPage - 1)}
          style={{
            padding: '5px 9px',
            fontSize: '12px',
            fontWeight: '700',
            borderRadius: '5px',
            border: '1px solid #cbd5e1',
            background: currentPage <= 1 ? '#f8fafc' : '#ffffff',
            color: currentPage <= 1 ? '#94a3b8' : '#1e293b',
            cursor: currentPage <= 1 ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <ChevronLeft size={14} />
        </button>

        <span style={{ padding: '0 8px', fontWeight: '700', color: '#0f172a' }}>
          Page {currentPage} of {totalPages}
        </span>

        <button
          type="button"
          disabled={currentPage >= totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          style={{
            padding: '5px 9px',
            fontSize: '12px',
            fontWeight: '700',
            borderRadius: '5px',
            border: '1px solid #cbd5e1',
            background: currentPage >= totalPages ? '#f8fafc' : '#ffffff',
            color: currentPage >= totalPages ? '#94a3b8' : '#1e293b',
            cursor: currentPage >= totalPages ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
};

export default ReportCardPagination;
